import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetCCDashboardExportReportInterface {
  startDate: string;
  endDate: string;
  id: string;
}

export const useGetCCExportReport = () => {
  const mutate = useMutation(({ startDate, endDate, id }: GetCCDashboardExportReportInterface) => {
    return get(`/external-api/export_excel_with_date_range/${id}/${startDate}/${endDate}`, {
      responseType: 'blob',
    });
  });

  return mutate;
};

export default useGetCCExportReport;
